export default {
    topics: [
        {
            title: 'Standards',
            href: 'control-Button.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e7890',
            next: 'tocId-d66e7890',
        },
        {
            title: 'Statics',
            href: 'control-Help.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e8060',
            next: 'tocId-d66e8060',
        },
        {
            title: 'Advanced',
            href: 'control-DiagramEdit.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e8085',
            next: 'tocId-d66e8085',
        },
        {
            title: 'Containers',
            href: 'control-HPaned.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e8110',
            next: 'tocId-d66e8110',
        },
    ],
};

